import { render, staticRenderFns } from "./OvertimeRequest.vue?vue&type=template&id=85de1420&scoped=true&"
import script from "./OvertimeRequest.vue?vue&type=script&lang=js&"
export * from "./OvertimeRequest.vue?vue&type=script&lang=js&"
import style0 from "./OvertimeRequest.vue?vue&type=style&index=0&id=85de1420&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85de1420",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VDataTable,VPagination,VSelect,VTextField})
